/**
 * Sabit, dondurulmuş sözleşme gerçekleri — iş kuralı değil, ölçülmüş/tanımlanmış veri.
 */

/** Backend `app/modules/audit/actions.py` ile birebir (sırası dahil); `audit-labels.test.ts` korur. */
export const AUDIT_ACTIONS = [
  'auth.login_succeeded',
  'auth.login_failed',
  'auth.account_locked',
  'auth.logout',
  'auth.token_refreshed',
  'auth.refresh_reuse_detected',
  'auth.password_changed',
  'user.created',
  'user.updated',
  'user.password_reset',
  'user.deactivated',
  'user.sessions_revoked',
  'user.mcp_revoked',
  'user.unlocked',
  'group.created',
  'group.updated',
  'group.deleted',
  'group.permissions_updated',
  'group.kantars_updated',
  'group.firms_updated',
  'report.create',
  'report.update',
  'report.restore',
  'report.delete',
  'document.generate',
  'document.update',
  'document.refresh',
  'document.finalize',
  'document.delete',
  'document.pdf',
  'reconcile.override_set',
  'reconcile.override_deleted',
  'mcp.authorized',
  'mcp.tool_called',
  'hr.action_requested',
  'hr.process_run',
  'hr.request_created',
  'hr.request_resubmitted',
  'hr.request_approved',
  'hr.request_revision',
  'hr.request_cancelled',
  'hr.request_retried',
  'hr.action_cancelled',
  'hr.request_resolved',
  'hr.request_withdrawn',
] as const
